import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        loading: 0,
        updateCartCount: false
    },
    mutations: {
        loadingAdd(state) {
            state.loading += 1
        },
        loadingSubtract(state) {
            state.loading -= 1
        },
        updateCartCount(state) {
            state.updateCartCount = !state.updateCartCount
        },
    },
    getters: {
        loading: state => {
            return state.loading
        },
        updateCartCount: state => {
            return state.updateCartCount
        }
    },
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js